import { render, staticRenderFns } from "./NotificationPostReview.vue?vue&type=template&id=98b85fbc&scoped=true&"
import script from "./NotificationPostReview.vue?vue&type=script&lang=ts&"
export * from "./NotificationPostReview.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationPostReview.vue?vue&type=style&index=0&id=98b85fbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98b85fbc",
  null
  
)

export default component.exports